const $ = jQuery;
$(document).on('click', '[data-tab-trigger]', function (e) {
	e.preventDefault();
	const target = $(this).attr('data-tab-trigger');
	const $tabContainer = $(this).closest('.tab-container');
	const totalTabs = Number(getComputedStyle($tabContainer[0]).getPropertyValue('--tab-count'));
	const tabKey = Number($(this).attr('data-key'));
	const progressLeft = tabKey === 0 ? 0 : (tabKey / totalTabs) * 100;

	$tabContainer.find('.tab-active').removeClass('tab-active');
	$tabContainer.find('.tab-progress span').css('left', progressLeft + '%');
	$('[data-tab-trigger="' + target + '"],[data-tab="' + target + '"]').addClass('tab-active');
});
